import { Flower2 } from "lucide-react";

const WORDS = [
  "Custom Cakes",
  "Birthdays",
  "Weddings",
  "Baby Showers",
  "Cupcakes",
  "Macarons",
  "Made to Order",
  "San Diego",
];

const Row = () => (
  <div className="flex w-max items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl font-light italic text-[#5C4B47] sm:text-3xl">
          {w}
        </span>
        <Flower2 size={16} strokeWidth={1.25} className="shrink-0 text-[#C48B71]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="overflow-hidden border-y border-[#E8D8D3] bg-[#F4EFEB] py-6"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
